/**
 * Generated by orval 🍺
 * Do not edit manually.
 * STBportalen
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FactsAboutScaffolding,
  FactsAboutScaffoldingDto
} from '../../model';

import { customInstance } from '../../../mutator/custom-instance';
import type { ErrorType , BodyType } from '../../../mutator/custom-instance';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiFactsAboutScaffoldingProjectId = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<FactsAboutScaffolding>(
      {url: `/api/FactsAboutScaffolding/${projectId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiFactsAboutScaffoldingProjectIdQueryKey = (projectId: number,) => {
    return [
    `/api/FactsAboutScaffolding/${projectId}`
    ] as const;
    }


export const getGetApiFactsAboutScaffoldingProjectIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiFactsAboutScaffoldingProjectId>>, TError = ErrorType<unknown>>(projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiFactsAboutScaffoldingProjectId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiFactsAboutScaffoldingProjectIdQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiFactsAboutScaffoldingProjectId>>> = ({ signal }) => getApiFactsAboutScaffoldingProjectId(projectId, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiFactsAboutScaffoldingProjectId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiFactsAboutScaffoldingProjectIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiFactsAboutScaffoldingProjectId>>>
export type GetApiFactsAboutScaffoldingProjectIdQueryError = ErrorType<unknown>


export function useGetApiFactsAboutScaffoldingProjectId<TData = Awaited<ReturnType<typeof getApiFactsAboutScaffoldingProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiFactsAboutScaffoldingProjectId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiFactsAboutScaffoldingProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiFactsAboutScaffoldingProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiFactsAboutScaffoldingProjectId<TData = Awaited<ReturnType<typeof getApiFactsAboutScaffoldingProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiFactsAboutScaffoldingProjectId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiFactsAboutScaffoldingProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiFactsAboutScaffoldingProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiFactsAboutScaffoldingProjectId<TData = Awaited<ReturnType<typeof getApiFactsAboutScaffoldingProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiFactsAboutScaffoldingProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiFactsAboutScaffoldingProjectId<TData = Awaited<ReturnType<typeof getApiFactsAboutScaffoldingProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiFactsAboutScaffoldingProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiFactsAboutScaffoldingProjectIdQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiFactsAboutScaffolding = (
    factsAboutScaffoldingDto?: BodyType<FactsAboutScaffoldingDto>,
 signal?: AbortSignal
) => {


      return customInstance<FactsAboutScaffolding>(
      {url: `/api/FactsAboutScaffolding`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: factsAboutScaffoldingDto, signal
    },
      );
    }




export const getPutApiFactsAboutScaffoldingMutationKey = () => ['putApiFactsAboutScaffolding'] as const;

export const getPutApiFactsAboutScaffoldingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiFactsAboutScaffolding>>, TError,PutApiFactsAboutScaffoldingMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiFactsAboutScaffolding>>, TError,PutApiFactsAboutScaffoldingMutationVariables, TContext> => {

const mutationKey = getPutApiFactsAboutScaffoldingMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiFactsAboutScaffolding>>, PutApiFactsAboutScaffoldingMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putApiFactsAboutScaffolding(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiFactsAboutScaffoldingMutationResult = NonNullable<Awaited<ReturnType<typeof putApiFactsAboutScaffolding>>>
    export type PutApiFactsAboutScaffoldingMutationBody = BodyType<FactsAboutScaffoldingDto> | undefined
    export type PutApiFactsAboutScaffoldingMutationError = ErrorType<unknown>
    export type PutApiFactsAboutScaffoldingMutationVariables = {data?: BodyType<FactsAboutScaffoldingDto>}

    export const usePutApiFactsAboutScaffolding = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiFactsAboutScaffolding>>, TError,PutApiFactsAboutScaffoldingMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiFactsAboutScaffolding>>,
        TError,
        PutApiFactsAboutScaffoldingMutationVariables,
        TContext
      > => {
      return useMutation(getPutApiFactsAboutScaffoldingMutationOptions(options), queryClient);
    }
